import { render, staticRenderFns } from "./BaseDialogFull.vue?vue&type=template&id=53ce7dd3&scoped=true"
import script from "./BaseDialogFull.vue?vue&type=script&lang=js"
export * from "./BaseDialogFull.vue?vue&type=script&lang=js"
import style0 from "./BaseDialogFull.vue?vue&type=style&index=0&id=53ce7dd3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ce7dd3",
  null
  
)

export default component.exports